import { NavLink } from "react-router-dom";
import { BagIcon, HeartIcon, HomeIcon, SearchIcon, UserIcon } from "./icons";

const TABS = [
  { to: "/", label: "Home", Icon: HomeIcon, end: true },
  { to: "/search", label: "Search", Icon: SearchIcon, end: false },
  { to: "/cart", label: "Bag", Icon: BagIcon, end: false },
  { to: "/wishlist", label: "Wishlist", Icon: HeartIcon, end: false },
  { to: "/account", label: "Profile", Icon: UserIcon, end: false },
];

export function BottomNav() {
  return (
    <nav className="sticky bottom-0 z-20 flex items-center justify-between border-t border-stone-300 bg-white px-8 pb-5 pt-3">
      {TABS.map(({ to, label, Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            [
              "flex flex-col items-center gap-1 text-[11px] font-semibold tracking-wide",
              isActive ? "text-ink" : "text-stone-500",
            ].join(" ")
          }
        >
          <Icon />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
